import { cloudGroups, letterGroups } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.constants';
import { type UserQuotaGroupId, UserQuotaGroupType } from 'reactApp/types/QuotaCleaner';

export const getGroupType = (groupId?: UserQuotaGroupId) => {
    if (!groupId) {
        return UserQuotaGroupType.None;
    }
    return letterGroups.includes(groupId)
        ? UserQuotaGroupType.Letter
        : cloudGroups.includes(groupId)
        ? UserQuotaGroupType.Cloud
        : UserQuotaGroupType.None;
};
